<script>
import {
  required, requiredIf
} from "vuelidate/lib/validators";

export default {
    name: 'CreateModal',
    props:[
        "data"
    ],
    data() {
        return {
            form: {
                type: '',
                fullname:'',
                address:{}
            },
            submitted: false,
        };
    }, 
    validations: {
        form: {    
            router_id: {
                required: requiredIf(function () {
                    return this.form.type == 'l'
                })
            },
            ip: { required },
            type: { required },
        },
    },
    watch:{
        data(props){
            this.form = {...props}
            this.form['fullname']= props.fname + ' ' + props.lname 
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('modal-application')
        }
    },
};
</script>

<template>
<b-modal id="modal-application" size="lg" title="Başvuru Detay"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
                <label>Başvuru Tarihi</label>
                <input
                    v-model="form.created_at"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
           <div class="col-4">
            <div class="mb-3">
                <label>Bayi</label>
                <input
                    v-model="form.user_name"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
           <div class="col-4">
            <div class="mb-3">
                <label>Xdsl No</label>
                <input
                    v-model="form.xdsl"
                    type="text"
                    class="form-control"
                  />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
                <label>İsim Soyisim</label>
                <input
                    v-model="form.fullname"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
                <label>Tc</label>
                <input
                    v-model="form.tc_vkn"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
           <div class="col-4">
            <div class="mb-3">
                <label>Telefon</label>
                <input
                    v-model="form.phonenumber"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
                <label>Kullanıcı Adı</label>
                <input
                    v-model="form.username"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
                <label>Şifre</label>
                <input
                    v-model="form.password"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
           <div class="col-4">
            <div class="mb-3">
                <label>Tarife</label>
                <input
                    v-model="form.tariff_name"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-10">
            <div class="mb-3">
                <label>Adres</label>
                <input
                    v-model="form.address.address"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
           <div class="col-2">
            <div class="mb-3">
                <label>BBK</label>
                <input
                    v-model="form.address.bbk"
                    type="text"
                    class="form-control"
                    readonly
                  />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
                <label>Not</label>
                <input
                    v-model="form.note1"
                    type="text"
                    class="form-control"
                  />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <div>
                <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
            </div>
            <div>
                <b-button variant="light" @click="close()">Vazgeç</b-button>
                <b-button 
                    v-if="form.id"
                    type="submit" 
                    variant="warning" 
                    class="ms-1"
                    >Güncelle
                </b-button>
                <b-button 
                    v-else
                    type="submit" 
                    variant="success" 
                    class="ms-1"
                    >Oluştur
                </b-button>
            </div>
        </div>
    </form>
</b-modal>
</template>